export default "__VITE_ASSET__0c8652cf__"